var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-sticky"},[_c('div',{style:({'top': _vm.top + 'px'})},[_vm._t("default",function(){return [_vm._v("Test")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }